/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Placeholder_EmailInputs */

const da_legal_placeholder_email = /** @type {(inputs: Legal_Placeholder_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[kontakt-e-mail]`)
};

/** @type {(inputs: Legal_Placeholder_EmailInputs) => LocalizedString} */
const en_legal_placeholder_email = da_legal_placeholder_email;

/**

* @param {Legal_Placeholder_EmailInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_placeholder_email = /** @type {((inputs?: Legal_Placeholder_EmailInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Placeholder_EmailInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_placeholder_email(inputs)
	return /** @type {LocalizedString} */ ("[kontakt-e-mail]")
});